import { useEffect, useState } from "react";
import { api, fmtAUD } from "@/lib/api";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import PreviewBanner from "./PreviewBanner";

// Gallery grid: big product cards, masonry-ish (varied heights), hover reveal.
export default function ShopGallery() {
  const [products, setProducts] = useState([]);
  useEffect(() => {
    api.get("/products").then((r) => setProducts(r.data));
  }, []);

  // varied heights for masonry feel
  const heights = ["aspect-[3/4]", "aspect-[4/5]", "aspect-[3/4]", "aspect-[1/1]", "aspect-[3/4]", "aspect-[4/5]", "aspect-[3/4]"];

  return (
    <div className="pt-24 pb-24 px-6 md:px-10" data-testid="preview-shop-gallery">
      <PreviewBanner title="Gallery Grid" kind="Shop / Catalogue" />

      <div className="overline mb-4">Preview / Shop · Gallery</div>
      <h1 className="font-display uppercase text-5xl md:text-8xl tracking-tight leading-[0.9]">The<br />collection.</h1>

      <p className="mt-8 max-w-lg text-[#888]">Seven Pixels. Three tiers of doctrine. Presented visually — pick with your eyes, verify with the specs.</p>

      <div className="mt-16 columns-1 md:columns-2 lg:columns-3 gap-4 md:gap-6 [column-fill:_balance]">
        {products.map((p, i) => (
          <motion.a
            key={p.id}
            href={`/product/${p.slug}`}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.2 }}
            transition={{ duration: 0.7, delay: (i % 3) * 0.08, ease: [0.22, 1, 0.36, 1] }}
            className="block break-inside-avoid mb-4 md:mb-6 group"
            data-testid={`gallery-card-${p.slug}`}
          >
            <div className={`relative overflow-hidden ${heights[i % heights.length]} bg-[#080808] border border-[#1A1A1A]`}>
              <motion.img
                src={p.image_url}
                alt={p.name}
                className={`absolute inset-0 w-full h-full object-cover img-clip ${p.tier === "phantom" ? "phantom" : ""}`}
                whileHover={{ scale: 1.05 }}
                transition={{ duration: 1.2, ease: [0.22, 1, 0.36, 1] }}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#030303] via-transparent to-transparent" />
              {/* corner label */}
              <div className="absolute top-4 left-4 flex items-center gap-2">
                <span className={`tier-dot ${p.tier}`} />
                <span className="overline">TIER · {p.tier}</span>
              </div>
              {/* hover strip */}
              <div className="absolute inset-x-4 bottom-4 flex items-end justify-between">
                <div>
                  <div className="font-display text-2xl md:text-3xl tracking-tight">{p.name.split("//")[0]}</div>
                  <div className="overline text-[#888] mt-1">{p.model}</div>
                </div>
                <div className="text-right">
                  <div className="text-[#EAEAEA] font-mono text-base md:text-lg">{fmtAUD(p.price_aud)}</div>
                </div>
              </div>
              {/* hover overlay */}
              <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity bg-[#030303]/70">
                <div className="border border-[#EAEAEA] px-6 py-3 overline text-[#EAEAEA] flex items-center gap-2">
                  Open device <ArrowUpRight size={14} />
                </div>
              </div>
            </div>
          </motion.a>
        ))}
      </div>
    </div>
  );
}
